/**
 * Short German duration for timers and summaries: "47 Min.", "1 Std.", "1 Std. 32 Min."
 * Minutes granularity on purpose — work time is tracked in quarter hours, so seconds
 * would suggest a precision the data does not have.
 */
export function formatDurationDe(minutes: number): string {
  const total = Math.max(0, Math.floor(minutes))
  const hours = Math.floor(total / 60)
  const mins = total % 60
  if (hours === 0) return `${mins} Min.`
  if (mins === 0) return `${hours} Std.`
  return `${hours} Std. ${mins} Min.`
}
